import { Actions as COMPANY_ACTIONS } from "@/redux/actions/companyActions";
import { connect } from "react-redux";

import { ClipboardDocumentListIcon, ViewColumnsIcon } from "@heroicons/react/20/solid";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CompanyModal from "./company-list/CompanyModal";
import CompanyStatusIcon from "./icons/CompanyStatusIcon";
import Tooltip from "./tooltip/Tooltip";

const Navbar = ({ isAdvisor, advisorName, isAdmin, company, }) => {
	const navigate = useNavigate();
	const location = useLocation();

	const currentPage = location.pathname;
	const isOnAdvisor = currentPage.startsWith("/advisor");
	const isOnAdmin = currentPage.startsWith("/admin");
	const isOnOrganisation = currentPage.startsWith("/organisation");

	const Icon = useMemo(() => {
		return CompanyStatusIcon(company?.status);
	}, [company?.status]);

	return (
		<div className="btn-group">
			{isAdmin && (
				<Tooltip
					as="button"
					content={"Switch To Admin"}
					className="btn btn-default"
					type="button"
					disabled={isOnAdmin}
					onClick={() => navigate("/admin/organisations")}
				>
					<ClipboardDocumentListIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
					<div style={{ float: "left" }}>Admin</div>
				</Tooltip>
			)}
			{isAdvisor && (
				<Tooltip
					as="button"
					className="btn btn-default"
					type="button"
					position="bottom"
					disabled={isOnAdvisor}
					onClick={() => navigate("/advisor/clients")}
					content={"Switch To Advisor"}
				>
					<ViewColumnsIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
					<div style={{ float: "left" }}>{advisorName || "Advisor"}</div>
				</Tooltip>
			)}
			<div className="btn-group">
				<Tooltip
					as="button"
					position="bottom"
					className="btn btn-default"
					type="button"
					disabled={isOnOrganisation}
					onClick={() => navigate("/organisation/people")}
					content={"Switch to Company"}
				>
					{Icon && <Icon style={{ height: "1.5em", float: "left", marginRight: "0.5rem" }} />}
					{company?.name || "Company"}
				</Tooltip>
				<CompanyModal
					as="button"
					type="button"
					className="btn btn-default"
					style={{ paddingLeft: "0.5rem", paddingRight: "0.5rem" }}
				/>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { profile } = state.my;

	return {
		isAdvisor: profile.isAdvisor,
		advisorName: state.advisors?.settings?.name,
		company: {
			org: state.company?.settings?.org,
			name: state.company?.settings?.name,
			status: state.company?.settings?.isDemo ? "Demo" : state.company?.settings?.status,
		},
		isAdmin: profile.isAdmin,
		isCompanyModalOpen: state.company.isCompanyModalOpen,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setCompanyModal: (open) => dispatch(COMPANY_ACTIONS.setCompanyModal(open)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
